module.exports = __webpack_public_path__ + "media/mediaProfessionals/block-image-6-af2cf0d7.png";